import { useEffect, useState } from "react";
import { fmtError, fmtEUR, fmtDate } from "@/lib/api";
import { useTenant } from "@/context/TenantContext";
import { Loader2, Sparkles } from "lucide-react";

export default function HistoryPage() {
  const { api, info } = useTenant();
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!api) return;
    api.myTreatments().then(setItems).catch((e) => setError(fmtError(e)));
  }, [api]);

  if (!items) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="animate-spin text-[#A78BFA]" /></div>;
  }

  const total = items.reduce((s, t) => s + (t.price || 0), 0);
  const totalPoints = items.reduce((s, t) => s + (t.points_awarded || 0), 0);

  return (
    <div data-testid="history-page" className="max-w-4xl">
      <div className="text-[11px] tracking-[0.3em] uppercase text-[#A78BFA] mb-3">Cronologia</div>
      <h1 className="font-serif font-light text-4xl md:text-5xl tracking-tight text-[#1A1A1A]">
        I tuoi <span className="italic">trattamenti.</span>
      </h1>

      {error && <div className="mt-6 text-sm text-[#B91C1C]">{error}</div>}

      <div className="mt-8 grid sm:grid-cols-3 gap-4">
        <Stat label="Trattamenti totali" value={items.length} />
        <Stat label="Punti accumulati" value={totalPoints} />
        <Stat label="Speso lifetime" value={fmtEUR(total)} />
      </div>

      <div className="mt-12 rounded-3xl border border-black/5 bg-white overflow-hidden" data-testid="history-list">
        {items.length === 0 ? (
          <div className="p-12 text-center">
            <div className="font-serif text-2xl text-[#1A1A1A]">Ancora nessun trattamento</div>
            <p className="mt-2 text-[#4A4A4A] font-light">Prenota il tuo primo trattamento per iniziare a guadagnare punti ✨</p>
          </div>
        ) : (
          <ul className="divide-y divide-black/5">
            {items.map((t) => (
              <li key={t.id} data-testid={`history-${t.id}`} className="px-6 md:px-8 py-5 flex items-center gap-4">
                <div className="h-11 w-11 rounded-2xl bg-gradient-to-br from-[#F5F0FF] to-white border border-black/5 flex items-center justify-center">
                  <Sparkles size={18} className="text-[#A78BFA]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-[#1A1A1A]">{t.service_name}</div>
                  <div className="text-xs text-[#737373]">{fmtDate(t.performed_at, info?.timezone)}</div>
                  {t.notes && <div className="mt-1 text-sm text-[#4A4A4A] font-light italic">"{t.notes}"</div>}
                </div>
                <div className="text-right">
                  <div className="font-medium text-[#1A1A1A]">{fmtEUR(t.price)}</div>
                  {/* i punti dei trattamenti fatti in salone arrivano col pagamento, non qui */}
                  {t.points_awarded > 0 && <div className="text-xs text-[#A78BFA]">+{t.points_awarded} pt</div>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

const Stat = ({ label, value }) => (
  <div className="rounded-3xl border border-black/5 bg-white p-6">
    <div className="text-[10px] tracking-[0.25em] uppercase text-[#737373]">{label}</div>
    <div className="mt-2 font-serif font-light text-3xl text-[#1A1A1A]">{value}</div>
  </div>
);
